import React, { useState } from 'react'
import { Button } from 'react-bootstrap'
import { FormattedMessage } from 'react-intl'
import { useDispatch, useSelector } from 'react-redux'
import { getSelectedCustomer } from '../../../selectors/customers'
import AddApplicationModal from '../../../../app/pages/home/modals/AddApplicationModal'
import * as customers from '../../../ducks/customers'

function AddApplicationButton() {
  // Global state
  const dispatch = useDispatch()
  const selectedCustomer = useSelector(getSelectedCustomer)
  const allowPermissions = useSelector(({ userPermissions }) => userPermissions.data.permissions)
  const hasManagePermission = allowPermissions.discover === 'manage'
  // Local state
  const [modalAddApplicationShow, setModalAddApplicationShow] = useState(false)

  const onAddApplicationClick = () => {
    setModalAddApplicationShow(true)
  }

  const modalClose = () => {
    setModalAddApplicationShow(false)
  }

  const hasUpdated = () => {
    const updatedCustomer = { ...selectedCustomer }
    // Trigger refresh
    dispatch(customers.actions.setSelectedCustomer(updatedCustomer))
  }

  return (
    <>
      {hasManagePermission && (
        <Button onClick={() => onAddApplicationClick()} id="exportBtn" variant="light">
          <FormattedMessage id="SAASCONFIG.ADD_APPLICATION" />
        </Button>
      )}

      <AddApplicationModal
        show={modalAddApplicationShow}
        onHide={modalClose}
        onUpdate={hasUpdated}
        customer={selectedCustomer || undefined}
      />
    </>
  )
}

export default AddApplicationButton
